<!-- eslint-disable max-lines -->
<template>
    <paper v-loading="btnloading" class="mip-iframe sharing-rules" v-if="hasAuthorized">
        <div class="header-box">
            <h4>提成分配规则变更</h4>
            <div class="header-part">
                <div class="apply-info">
                    <div>变更单号：{{ detailDataLocal.flowCode }}</div>
                    <div>申请人：{{ detailDataLocal.createUserName }}</div>
                    <!-- <div>申请人部门：{{ detailDataLocal.departName }}</div> -->
                </div>
            </div>
        </div>
               <!-- 按钮区域 -->
        <div class="detail-toolBar">
            <lots-button type="primary" v-if="sharingRulesShow['saveBtn']"
                :loading="saveLoading"
                @click="handleSave">保存
            </lots-button>
            <lots-button type="primary" v-if="sharingRulesShow['submitBtn']"
                  :loading="subLoading" @click="handleSubmit">提交审批
            </lots-button>
        </div>
        <div class="list-box third-box">
            <el-form
                ref="outForm"
                :model="detailDataLocal"
                label-width="100px"
                label-position="left"
                :rules="rules">
                <el-form-item label="流程标题" prop="flowTitle">
                    <el-input v-model="detailDataLocal.flowTitle"  :disabled="readonly" clearable></el-input>
                </el-form-item>
                <el-form-item label="变更说明" prop="changeRemark">
                    <el-input type="textarea" v-model="detailDataLocal.changeRemark" rows="4"  :disabled="readonly"></el-input>
                </el-form-item>

            </el-form>
        </div>
           <div class="list-box" >
            <el-menu
                :default-active="isFull"
                class="el-menu-demo"
                mode="horizontal">
                <el-menu-item index="sharing">变更明细</el-menu-item>
            </el-menu>
            <search-box
                ref="searchBoxQuery"
                :search-key="config.name"
                v-if="sharingRulesShow['searchBtn']"
                :fields="newConfig.searchFields.querySearchFields"
                :showResetBtn="true"
                :searchBtnBoxSpan="8"
                @search-change="detailList.searchList">
                <template slot="btn-append">
                    <!-- <lots-button type="primary" @click="queryHandle()">查询</lots-button> -->
                    <lots-button type="primary" @click="changeData" :disabled="!sharingRulesShow['pickBtn']" v-if="!sharingRulesShow['pickStatusBtn']">选取变更</lots-button>
                    <lotsButton
                        icon="el-icon-upload2"
                        type="primary"
                        size="mini"
                        title="导入"
                       :disabled="sharingRulesShow['importStatusBtn']"
                        v-if="sharingRulesShow['importBtn']"
                        @click="openImport">导入更新
                    </lotsButton>
                    <lots-button type="primary" :disabled="sharingRulesShow['exportBtn']" icon="el-icon-download" size="mini" @click="handleExport"
                        :loading="detailExportLoading">导出</lots-button>
                    <lotsButton
                        icon="el-icon-delete"
                        type="primary"
                        size="mini"
                        title="删除"
                        @click="handleDelete">删除
                    </lotsButton>
                </template>
            </search-box>
            <edit-table-box
                ref="editTableBox"
                :key="selectKey"
                v-loading="detailList.tableLoading"
                :control="!!sharingRulesShow['delBtn']"
                :selection="config.selection"
                :columns="newConfig.columns.detailColumns"
                :height="300"
                :tableData="detailList.totalData"
                :allowRowClick="!!sharingRulesShow['delBtn']"
                :actions="config.actions"
                @btn-event="actionClick"
                @selection-change="detailList.handleSelectedRow"
                @element-change="handleChangeRow"
                >
                    <template #col-header="{ item }">
                        <div class="income-date-change" v-if="item.prop==='effectStartTime' && isPrivilege && sharingRulesShow['importBtn']">
                            {{ item.label }}
                                <el-tooltip class="item" effect="dark" content="批量更新当前页生效日期" placement="top-start">
                                    <el-date-picker
                                        v-model="changeEffectTime"
                                        type="date"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        @change="changeEffecttimeHandle"
                                        >
                                    </el-date-picker>
                             </el-tooltip>
                        </div>
                        <span v-else>{{ item.label }}</span>
                    </template>
            </edit-table-box>
            <lots-pagination
                @size-change="detailList.sizeChange"
                :current-page.sync="detailList.pageNo"
                @current-change="detailList.pageChange"
                layout="total, sizes, prev, pager, next, jumper"
                :total="detailList.pageTotal" >
            </lots-pagination>
        </div>
        <div>
            <div class="upload-box">
                <span class="upload-label" >附件</span>
                <el-button class="upload-sharing-btn" type="primary"
                    @click="upLoadData"  :disabled="!sharingRulesShow['fileBtn']" v-if="sharingRulesShow['fileStatusBtn']">
                附件上传
                </el-button>
                <!-- <lots-upload-button :text="'上传附件'" :bucket="'annto-lcrm'" :disabled="['3','4'].includes(detailDataLocal.mipStatus+'')"
                            @callback="(data) => { upLoadData(form, itemSetting, data); }">
                        </lots-upload-button> -->
            </div>
            <div class="file-infos">
                <template v-if="detailDataLocal.enclosureList && detailDataLocal.enclosureList.length">
                    <div
                        class="file-list"
                        v-for="(item, index) in detailDataLocal.enclosureList"
                        :key="index + item.accessoryName">
                        <div
                            class="file-name upload"
                            :title="item.accessoryName">
                            {{`${index+1}. `}}
                            <a :href="item.internalSealFileUrl" target="_blank">{{ item.accessoryName }}</a>
                        </div>
                        <div class="delete-btn">
                            <el-button
                                type="text"
                                plain
                                @click="handlePreview(item)">
                                预览
                            </el-button>
                            <el-button
                                type="text"
                                plain>
                                <a :href="item.internalSealFileUrl" target="_blank">下载</a>
                            </el-button>
                            <el-button
                                type="text"
                                plain
                                @click="handleDeleteFile(item)"
                                :disabled="!sharingRulesShow['fileBtn']">删除</el-button>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div
            v-if="detailDataLocal.mipId"
            class="iflow-box">
            <div class="header-operation">
                <lots-button
                    size="mini"
                    type="primary"
                    @click="submitMip()"
                    :loading="btnloading || submitLoading">
                    mip提交
                </lots-button>
            </div>
            <iframe
                class="ifr"
                :src="mipUrl"
                v-if="!btnloading" />
        </div>
                <!-- 导入弹窗 -->
            <!-- 新增弹窗 -->
        <el-dialog
            @close="closeLog"
            v-loading="importLoading"
            title="附件新增"
            :visible.sync="addDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="470px">
            <el-form
                :model="filesForm"
                label-position="right"
                class="form-dialog"
                label-width="80px"
                ref="filesFormDialog">
                <div class="upload-btn">
                    <lots-button size="mini" type="primary" v-if="showDownload" @click="downLoad()"
                        :loading="downloadLoading">下载模板</lots-button>
                    <lots-upload-button ref="uploadPickRef" :text="'上传附件'" v-if="showDownload" :bucket="'annto-lcrm'" :accept="config.importConfig.accept"
                        @beforeUpload="beforeUploadPick" @callback="(data) => { getUploadFilePick(data); }">
                    </lots-upload-button>
                    <lots-upload-button ref="uploadRef" :text="'上传附件'" v-if="!showDownload" :bucket="'annto-lcrm'" :disabled="readonly" :accept="config.importConfig.accept"
                        @beforeUpload="beforeUploadUrl" @callback="(data) => { upLoadFileUrl( data); }">
                    </lots-upload-button>
                </div>
                <el-form-item label="附件名称" prop="accessoryName">
                    <span>{{showDownload?filesForm.accessoryName:fileUrlList.accessoryName}}</span>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <lots-button size="mini" @click="closeLog">取 消</lots-button>
            <lots-button size="mini" type="primary" @click="incrementImport(2)"
                >导入</lots-button>
            </span>
        </el-dialog>
        <advance-multi-dialog
            ref="advanceMultiDialog"
            @confirm="contractSaveSure">
        </advance-multi-dialog>

    </paper>
    <div class="no-auth-reg income-sharing" v-else>{{!detailDataLocal.id ?'':"抱歉，您暂时无权查看"}}</div>
</template>

<script>
import { ref, reactive, onActivated, computed, getCurrentInstance, onMounted } from '@vue/composition-api';
import paper from '@/components/core/Paper.vue';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import { tableConfig } from './config.js';
// import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import editTableBox from '@/components/lots/editTableBox/Index';
import { neoRespChangeSave, updateSharingRules,
    saveSharingRules, addDetailList, sharingRulesExport, sharingRulesImport, delDetailList, getCurrentUserRole,
    sharingRulesSubmit, queryDetailInfo, queryDetailList, sharingRulesFileImport, sharingFileDel, updateDetailList
    , sharingRulesCheck, getCurrentPrivilegeRole, updateEffectDate,
    getCurrentPrivilege
} from '@mdm/api/customer/customerPersonResponserEdit.js';
import { approveProcess } from '@/modules/mdm/api/contractManage/detailMainApi.js';
import { contractWorkflowList } from '@mdm/api/contractManage/contractFootPageApi.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { Message, MessageBox } from 'element-ui';
import {
    getAuthorByProcessIdApi
} from '@mdm/api/contractManage/mipIframeApi.js';
// import DialogImportFile from '@/components/lots/DialogImportFile/Index';
// import reportExport from '@/components/lots/reportExportPlugin';
import lotsUploadButton from '@/components/lots/oss/UploadBtn';
import store from '@/store/index';
import utils from '@/components/utils/common.js';
import _ from 'lodash';
import configurl from '@/config/user.env';
import advanceMultiDialog from '@/components/lots/otpAdvanceMultiDialog';
import { getNodesAndOperationApi } from '@mdm/utils/flowUtils.js';
import { filePreview } from '@/utils/filePreview.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
const { MAGIC_NUMBER } = utils;
export default {
    name: 'customerPersonResponserEdit',
    components: { paper, searchBox, lotsButton, editTableBox, lotsUploadButton, lotsPagination, advanceMultiDialog },
    // eslint-disable-next-line max-lines-per-function
    setup(props, setupContext) {
        // const EDIT_TYPE = {
        //     EDIT: 2,
        //     CANCEL: -3
        // };
        const { orgName, userName, userCode } = store.getters.user;
        const ctx = getCurrentInstance(); // 通过该方法访问当前组件的实例对象,相当于this
        const config = _.cloneDeep(tableConfig);
        const btnloading = ref(false);
        const detailLoading = ref(false);
        const isFull = ref('sharing');
        const changeEffectTime = ref();
        const detailDataLocal = ref({
            customerChange: '',
            applicant: '',
            applicantCode: '',
            applicantName: '',
            departName: '',
            flowTitle: '',
            changeRemark: '',
            enclosureList: [],
            mipId: '',
            mipStatus: '',
            respType: '' // 责任人类型（1：行业 2：分公司）
        });
        const selectKey = ref(false);

        const submitLoading = ref(false);
        const readonly = computed(() => {
            return [2, 3, 4, 7].includes(+detailDataLocal.value.mipStatus) || submitLoading.value || btnloading.value;
        });
        // * 1：草稿；
        // * 2：待审批；
        // * 3：审批中；
        // * 4：审批通过；
        // * 5：审批驳回；
        // * 6：撤回；
        // * 7：作废
        const sharingRulesShow = computed(() => {
            const { id, mipId } = detailDataLocal.value;
            return {
                'saveBtn': !id || !mipId || ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString()), // 未生成变更单、未提交审批
                'submitBtn': detailDataLocal.value.id && !detailDataLocal.value.mipId, // 已生成变更单、未提交审批
                'searchBtn': !!id,
                'pickBtn': mipId ? ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString()) : detailDataLocal.value.id,
                'importBtn': mipId ? ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString()) : id,
                'exportBtn': !detailDataLocal.value.id,
                'delBtn': mipId ? ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString()) : detailDataLocal.value.id,
                'fileBtn': mipId ? ['1', '5', '6'].includes(detailDataLocal.value.mipStatus?.toString()) : detailDataLocal.value.id,
                'importStatusBtn': mipId ? ['2', '3', '4'].includes(detailDataLocal.value.mipStatus?.toString()) : !detailDataLocal.value.id,
                'pickStatusBtn': ['2', '3', '4'].includes(detailDataLocal.value.mipStatus?.toString()),
                'fileStatusBtn': mipId ? !['2', '3', '4', '7'].includes(detailDataLocal.value.mipStatus?.toString()) : detailDataLocal.value.id
            };
        });
        const rules = reactive({
            flowTitle: [
                { required: true, message: '请填写流程标题', trigger: 'blur' }
            ],
            changeRemark: [
                { required: true, message: '请填写变更说明', trigger: 'blur' }
            ],
            enclosureList: [
                {
                    required: false,
                    validator: (rule, value, callback) => {
                        if (rule.required && !value.length) {
                            callback(new Error('附件不能为空'));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'change'
                }
            ]
        });
        const newConfig = computed(() => {
            const newSearchFields = _.cloneDeep(config.searchFields);
            const querySearchFields = [];
            newSearchFields.forEach(item => {
                // 必须发放在最后
                querySearchFields.push(item);
            });
            const queryColumns = [];
            config.columns.forEach((item) => {
                queryColumns.push(item);
            });
            return {
                ...config,
                searchFields: {
                    querySearchFields,
                    detailSearchFields: config.searchFields
                },
                columns: {
                    queryColumns,
                    detailColumns: config.columns
                }
            };
        });

        class DetailListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition, {}, 'detail');
            };
            afterGetList(res) {
                if (+res.code === 0 && res.data) {
                    this.pageTotal.value = res.data.totalCount;
                    if (res.data.list) {
                        this.totalData.value = res.data.list.map(it => {
                            return {
                                edit: -3,
                                allowEdit: false,
                                ...it,
                                calCustomerLevelCodeCn: codeToName(it.calCustomerLevelCode, 'NEOCRM_CUSTOMER_LEVEL'),
                                customerGroupCodeCn: codeToName(it.customerGroupCode, 'SYS_CUST_RELATION_TYPE'),
                                ...setOwnerList(it.ownerFlowList)
                            };
                        });
                    } else {
                        this.totalData.value = [];
                    }
                }
            };
        };
        const detailList = new DetailListClass({
            Api: {
                listApi: queryDetailList // 责任人变更明细查询接口
            }
        });
        const hasAuthorized = computed(() => {
            // 判断创建人也可以查看
            let isCreater = detailDataLocal.value.id ? detailDataLocal.value.createUserCode === userCode : true;
            if (initShowLoading.value) {
                isCreater = false;
            }
            return isCreater || authorized.value || currentUseRole.value;
        });
        const authorized = ref(false);

        const getIflowhandlers = async (fdId) => {
            // if (env === 'ver') {
            //     authorized.value = true;
            //     return false;
            // }
            if (!fdId) return;
            const authorityMips = [];
            // const publicPrarms = { fdId, loginName: store.getters.user.userCode };
            let res = null;
            res = await getAuthorByProcessIdApi({ fdProcessId: [fdId], loginName: store.getters.user.userCode }).catch(() => {
                btnloading.value = false;
            });

            if (+res.code === 0 && res.data && res.data.length) {
                const theData = res.data.find(item => item.fdProcessId === fdId);
                authorized.value = theData?.reader;
            }
            if (ctx.$route.query.isToOtherPersons) { // 传阅人也可以查看
                authorityMips.push(ctx.$route.query.isToOtherPersons);
            }
            authorized.value = authorized.value || authorityMips.some(item => item.includes(store.getters.user.userCode));
        };
        const currentAuth = ref(false);
        // eslint-disable-next-line max-lines-per-function
        const refleshPage = () => {
            const { flowCode } = ctx.$route.query;
            detailList.getList();
            detailDataLocal.value.applicant = userCode;
            detailDataLocal.value.applicantName = userName;
            const orgArr = orgName.split('_');
            detailDataLocal.value.departName = orgArr[orgArr.length - 2];
            if (!flowCode) return;
            const params = {
                flowCode,
                pageNo: detailList.pageNo.value,
                pageSize: detailList.pageSize.value
            };
            return queryDetailInfo(params).then(async res => {
                if (res && +res.code === 0 && res.data) {
                    detailDataLocal.value = res.data;
                    if (res.data.contractWorkflowInfo) {
                        detailDataLocal.value.mipId = res.data.contractWorkflowInfo.mipId;
                        detailDataLocal.value.mipStatus = res.data.contractWorkflowInfo.mipStatus;
                        detailDataLocal.value.mipUrl = res.data.contractWorkflowInfo.mipUrl;
                        detailDataLocal.value.mipCreater = res.data.contractWorkflowInfo.createUserCode;
                    }
                    detailDataLocal.value = {
                        // ...res2.data,
                        ...detailDataLocal.value
                    };

                    // 获取当前流程操作人
                    Reflect.deleteProperty(detailDataLocal.value, 'flowDetailList');
                    currentAuth.value = getNodesAndOperationApi({ fdId: detailDataLocal.value.mipId, loginName: userCode });
                    handleCreate();
                }
            }).catch(() => {
                btnloading.value = false;
                initShowLoading.value = false;
            }).finally(() => {
                initShowLoading.value = false;
            });
        };
        const isShowBtnFlow = computed(() => {
            return currentAuth.value; // 审批通过 || 当前操作人 || 流程提交人
        });
        const codeToName = (codes, optionsKey) => {
            const dictObj = dictDatas.value[optionsKey];
            const names = [];
            let codesArr = [];
            if (codes && Array.isArray(codes)) {
                codesArr = codes;
            } else if (codes) {
                codesArr = codes.split(',');
            }
            if (codesArr && codesArr.length) {
                codesArr.forEach((key) => {
                    if (dictObj && dictObj[key]) {
                        names.push(dictObj[key]); // dictData.value['SYS_BMS_BUSI_TYPE']
                    }
                });
            }
            return names.join(',');
        };
        const setOwnerList = data => {
            if (!(Array.isArray(data) && data.length)) return {};
            const ownerNameObj = {};
             // eslint-disable-next-line no-unused-expressions
             data?.forEach((it, index) => {
                 const ownerName = 'ownerName' + (index + 1);
                 const ownerCode = 'ownerCode' + (index + 1);
                 const ownerRatio = 'ownerRatio' + (index + 1);
                 const ownerId = 'ownerId' + (index + 1);
                 ownerNameObj[ownerName] = it.ownerName;
                 ownerNameObj[ownerCode] = it.ownerCode;
                 ownerNameObj[ownerRatio] = it.ownerRatio;
                 ownerNameObj[ownerId] = it.id;
             });
             return ownerNameObj;
        };
        const fileList = ref([]);
        const filesForm = ref({});
        const addDialog = ref(false);
        const downloadLoading = ref(false);
        const openImport = () => {
            showDownload.value = true;
            filesForm.value.accessoryName = '';
            fileUrlList.value = {};
            addDialog.value = true;
        };
        const downLoad = (data) => {
            downloadLoading.value = true;
            sharingRulesExport({ flowCode: detailDataLocal.value.flowCode, fileName: '提成分配规则导入模板.xlsx' }).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送下载模版请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { downloadLoading.value = false; });
        };
        const beforeUploadPick = res => {
            const isValid = checkFile(res.file, 'uploadPickRef');
            if (!isValid) return;
            updateData.value['fileName'] = res.file.name;
            setupContext.refs.uploadPickRef.handleUploadStatus(true);
        };
        // 增量/覆盖导入
        const getUploadFilePick = res => {
            if (+res.code === 0 && res.data) {
                updateData.value = { ...updateData.value, ...res.data };
                filesForm.value.accessoryName = res.data?.name || updateData.value.fileName;
                ctx.$forceUpdate();
            } else {
                updateData.value = { };
            }
        };
        const fileUrlList = ref({ accessoryName: '' });
        const beforeUploadUrl = res => {
            const isValid = checkFile(res.file, 'uploadRef');
            if (!isValid) return;
            fileUrlList.value = {
                accessoryName: res.file.name
            };
            setupContext.refs.uploadRef.handleUploadStatus(true);
        };
        // 文件校验
        const checkFile = (file, type) => {
            // 限制文件格式
            if (config.importConfig.accept) {
                const extension = file.name.split('.').pop(); // 获取文件扩展名
                const isAccept = config.importConfig.accept.indexOf(extension) !== -1;
                if (!isAccept) {
                    Message.warning(config.importConfig.fileType || '文件格式不对，请重新上传');
                    setupContext.refs[type].handleUploadStatus(false);
                    setupContext.refs[type].uploadDataArr = [];
                    return false; // 阻止文件上传
                }
            }

            // 限制文件大小
            const BYTES_UNIT = 1024;
            const limitSize = dictDatas.value?.LCRM_IMPORT_MAX_SIZE?.customerManagerImport || 10;
            if (file.size > limitSize * BYTES_UNIT * BYTES_UNIT) {
                Message.warning('上传文件不能大于' + limitSize + 'M');
                setupContext.refs[type].handleUploadStatus(false);
                setupContext.refs[type].uploadDataArr = [];
                return false; // 阻止文件上传
            }

            return true; // 允许文件上传
        };
        const upLoadFileUrl = (res) => {
            if (res && +res.code === 0) {
                filesForm.value.accessoryName = res.data.name;
                fileUrlList.value = {
                    internalSealFileUrl: res.data.downUrl,
                    contractCode: detailDataLocal.value.flowCode,
                    accessoryName: res.data.name
                };
            }
        };
        const bottomFileImport = () => {
            if (!fileUrlList.value.internalSealFileUrl) return '请上传附件';
            sharingRulesFileImport(fileUrlList.value).then(res => {
                if (res && +res.code === 0) {
                    Message.success('上传成功');
                    addDialog.value = false;
                }
            });
        };
        // 增量/覆盖导入
        const incrementImport = async (val) => {
            if (!showDownload.value) {
                return bottomFileImport();
            }
            if (!updateData.value?.downUrl) {
                return Message.warning('请先上传附件');
            }
            const params = {
                flowCode: detailDataLocal.value.flowCode,
                fileUrl: updateData.value?.downUrl,
                fileName: updateData.value?.fileName
            };
            // 处理URL后面的参数拼接

            // 把接口需要的参数带进去
            importLoading.value = true;
            sharingRulesImport(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('导入成功');
                    detailList.getList();
                    addDialog.value = false;
                }
            }).catch(() => { importLoading.value = false; }).finally(() => {
                importLoading.value = false;
            });
        };
        const closeLog = () => {
            fileList.value = [];
            filesForm.value.accessoryName = '';
            addDialog.value = false;
            refleshPage();
        };
        // 上传失败
        const handleError = () => {
            Message.error('上传失败');
        };
        const onChange = (file) => {
            fileList.value = [];
            filesForm.value.accessoryName = file.name;
            fileList.value.push(file);
        };
        const importLoading = ref(false);
        // 导入
        const handleImport = async() => {
            if (!fileList.value.length) {
                return Message.warning('请先上传附件');
            }
            const formData = new FormData();
            // 把接口需要的参数带进去
            formData.append('file', fileList.value[0].raw);
            formData.append('contractCode', detailDataLocal.value.flowCode);
            formData.append('fileType', filesForm.value.accessoryName);
            formData.append('userName', userName);
            formData.append('userCode', userCode);
            formData.append('accessoryName', filesForm.value.accessoryName);
            formData.append('contractCharacter', 1);
            let res = null;
            importLoading.value = true;
            try {
                res = await sharingRulesImport(formData);
                importLoading.value = false;
            } catch (error) {
                importLoading.value = false;
            }
            if (+res.code === 0) {
                Message.success('导入成功');
                detailList.getList();
                closeLog();
            } else {
                // 报错清空文件
                fileList.value = [];
                filesForm.value.accessoryName = '';
            }
        };
        const detailExportLoading = ref(false);
        const handleExport = () => {
            const params = {
                flowCode: detailDataLocal.value.flowCode
            };
            detailExportLoading.value = true;
            sharingRulesExport(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { detailExportLoading.value = false; });
        };
        // eslint-disable-next-line max-lines-per-function
        const changeData = () => {
            const _config = _.cloneDeep(config);
            _config.contractAdvanceParams.advanceConfig.forEach(it => {
                if (it.prop === 'maintainStatusList' && !roleAuth.value) { // true 显示2个选项(原配置即可), false显示一个
                    delete it.optionsKey;
                    it.options = {
                        '1': '草稿'
                    };
                }
            });
            // eslint-disable-next-line no-unused-expressions
            _config.contractAdvanceParams.beforeRequest = (params) => {
                const { customerGroupCodes: customerGroupCodeList, customerCodes: customerCodeList, companyCodes: companyCodeList, businessCenterCodes: businessCenterCodeList,
                    ownerCodes: ownerCodeList, billDepartmentNames: billDepartmentNameList, billDepartmentCodes: billDepartmentCodeList, ...rest } = params;
                const newParams = {
                    customerGroupCodeList,
                    customerCodeList,
                    companyCodeList,
                    businessCenterCodeList,
                    ownerCodeList,
                    billDepartmentNameList,
                    billDepartmentCodeList,
                    ...rest
                };
                Object.keys(newParams).forEach(v => {
                    if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                        delete newParams[v];
                    }
                });
                const keys = ['customerGroupCodeList', 'customerCodeList', 'companyCodeList', 'businessCenterCodeList',
                    'ownerCodeList', 'billDepartmentNameList', 'billDepartmentCodeList'];
                keys.forEach(key => {
                    if (newParams[key]) {
                        newParams[key] = newParams[key].split(',');
                    }
                });
                Reflect.deleteProperty(newParams, 'customerGroupCodes');
                Reflect.deleteProperty(newParams, 'customerGroupNames');
                Reflect.deleteProperty(newParams, 'businessCenterNames');
                Reflect.deleteProperty(newParams, 'companyNames');
                Reflect.deleteProperty(newParams, 'customerNames');
                Reflect.deleteProperty(newParams, 'ownerNames');
                Reflect.deleteProperty(newParams, 'billDepartmentCodes');
                Reflect.deleteProperty(newParams, 'billDepartmentNames');
                newParams.failTime = '2099-1-1';
                newParams.isRelationFlow = '0';
                if (newParams.maintainStatusList) {
                    newParams.maintainStatusList = newParams.maintainStatusList.split(',');
                } else {
                    newParams.maintainStatusList = !roleAuth.value ? ['1'] : ['1', '3'];
                }
                newParams.orderBy = 'maintain_status';
                newParams.orderByType = 'asc';
                return newParams;
            };
            setupContext.refs.advanceMultiDialog.show(true, _config.contractAdvanceParams, {});
        };
        const contractSaveSure = async (data) => {
            const list = data.map(it => {
                it.flowCode = detailDataLocal.value.flowCode;
                return it;
            });
            addDetailList(list).then(res => {
                if (res && +res.code === 0) {
                    Message.success('添加成功');
                }
            }).finally(() => {
                detailList.getList();
            });
        };
        const saveLoading = ref(false);
        const handleSave = () => {
            setupContext.refs.outForm.validate(async(flag) => {
                if (flag) {
                    saveLoading.value = true;
                    const params = {
                        ...detailDataLocal.value,
                        flowDetailList: rowsFormatFn(detailList.totalData.value)
                    };
                    const api = detailDataLocal.value.id ? updateSharingRules : saveSharingRules;
                    api(params).then(res => {
                        if (res && +res.code === 0) {
                            Message.success('保存成功');
                            if (detailDataLocal.value.id) return;
                            const { origin, pathname } = window.location;
                            window.location.assign(`${origin}${pathname}#/incomeSharingRules?flowCode=${res.data}`);
                            refleshPage();
                        }
                    }).finally(() => {
                        saveLoading.value = false;
                    });
                }
            });
        };

        /**
         * 校验记录数组并返回不符合规则的记录
         * @param {Array} records - 要校验的记录数组
         * @param {Object} relatedBillInfo - 关联单据信息 { billNumber: { effectiveDate: Date } }
         * @returns {Array} 包含错误信息的数组，格式为 { name: 记录名称, errors: [错误信息] }
         */
        const eighty = '80';
        const safeToNumber = (value) => {
            // 明确排除空字符串、null、undefined
            if (value === '' || value === null || value === undefined) {
                return undefined;
            }

            // 处理字符串'0'的情况
            if (value === '0') return 0;

            // 使用lodash的toNumber转换
            const num = _.toNumber(value);

            // 确保是有限数字且不是NaN
            return _.isFinite(num) ? num : undefined;
        };
        const isEmptyName = (name) => {
            return _.isNil(name) || _.toString(name).trim() === '';
        };
        // eslint-disable-next-line max-lines-per-function
        const validateRecords = (dataArray) => {
            // eslint-disable-next-line complexity
            const errors = [];

            // 定义需要校验的字段
            const ownerFields = ['ownerRatio1', 'ownerRatio2', 'ownerRatio3', 'ownerRatio4', 'ownerRatio5'];
            const ownerNameFields = ['ownerName1', 'ownerName2', 'ownerName3', 'ownerName4', 'ownerName5'];
            const commonFields = ['industryCommonPoolRatio', 'companyCommonPoolRatio'];
            const allRatioFields = [...ownerFields, ...commonFields];
            const requiredFields = ['ownerRatio1', 'industryCommonPoolRatio', 'companyCommonPoolRatio'];

            _.forEach(dataArray, (record, index) => {
                const recordErrors = [];
                const recordNumber = index + 1;

                // 转换所有比例为数字，使用安全转换方法
                const ratios = _.mapValues(_.pick(record, allRatioFields), safeToNumber);

                // 规则1: 必填字段至少有一个有效值
                const hasRequiredField = _.some(requiredFields, field =>
                    !_.isUndefined(ratios[field])
                );

                if (!hasRequiredField) {
                    recordErrors.push('主责任人、行业公共池、分公司公共池至少填写一个');
                }

                // 规则2: 责任人比例校验
                _.forEach(ownerFields, (ratioField, i) => {
                    const nameField = ownerNameFields[i];
                    const ratio = ratios[ratioField];
                    const name = record[nameField];
                    // 责任人名称有值时，对应比例必填
                    // 情况1: 有名称必须有比例
                    if (!isEmptyName(name) && _.isUndefined(ratio)) {
                        recordErrors.push(`责任人${i + 1} "${name}" 有名称但未填写比例`);
                    }

                    // 情况2: 有比例必须有名称
                    if (!_.isUndefined(ratio) && isEmptyName(name)) {
                        recordErrors.push(`责任人${i + 1} 填写了比例 ${ratio}% 但未填写名称`);
                    }

                    // 比例不能超过80%
                    if (!_.isUndefined(ratio) && (ratio > +eighty || ratio < 0)) {
                        recordErrors.push(`责任人${i + 1}比例必须在0-80%之间`);
                    }
                });

                // 规则2: 公共池比例校验
                _.forEach(commonFields, field => {
                    const ratio = ratios[field];
                    if (!_.isUndefined(ratio)) {
                        if (ratio < 0) {
                            recordErrors.push(`${field}必须大于等于0`);
                        }
                    }
                });

                // 规则3: 所有比例汇总等于100%
                const sum = _.reduce(allRatioFields, (total, field) => {
                    const val = ratios[field];
                    return total + (_.isNumber(val) ? val : 0);
                }, 0);

                if (sum !== 100) {
                    recordErrors.push(`所有比例之和必须等于100%，当前为${sum}%`);
                }

                if (recordErrors.length > 0) {
                    errors.push({
                        recordName: record.name || `记录${recordNumber}`,
                        errors: recordErrors
                    });
                }
            });

            return {
                isValid: errors.length === 0,
                errors: errors
            };
        };
        const actionClick = (row, event, index) => {
            if (event === 'del') {
                delAction(row);
            } else if (event === 'save') {
                saveAction(row);
            }
        };
        // 判断责任人是否重复
        const getDetailedDuplicates = (array) => {
            const results = _.map(array, (item) => {
                const ownerFlowList = item.ownerFlowList || [];
                const codeMap = {};
                const duplicateCodes = new Set();

                _.each(ownerFlowList, (owner) => {
                    const code = owner.ownerCode;
                    if (code in codeMap) {
                        duplicateCodes.add(String(code)); // 确保code转为字符串
                    } else {
                        codeMap[code] = true;
                    }
                });

                return Array.from(duplicateCodes).join(',');
            });

            // 过滤掉空字符串的结果
            return _.filter(results, codeStr => codeStr !== '');
        };
        const saveAction = (row) => {
            const validationResult = validateRecords([row]);
            if (!validationResult.isValid) {
                let tipsError = '';
                validationResult.errors.forEach(it => {
                    it.errors.forEach((err, index) => {
                        tipsError = tipsError + err + '<br />';
                    });
                });
                Message.warning({
                    message: tipsError,
                    dangerouslyUseHTMLString: true
                });
                return;
            }
            const checkTableData = _.cloneDeep([row]).map(item => {
                delete item.backup;
                delete item.edit;
                delete item.allowEdit;
                delete item.ownerFlowList;

                item.ownerFlowList = mergeOwnersToArray(item);
                return item;
            });
            const isRepeatUserCode = getDetailedDuplicates(checkTableData);
            if (isRepeatUserCode.length) {
                return Message.warning('当前责任人重复:' + isRepeatUserCode.join(',') + ',请修改');
            }
            updateDetailList(checkTableData[0]).then(res => {
                if (res && +res.code === 0) {
                    Message.success('保存成功');
                    detailList.getList();
                }
            });
        };
        const mergeOwnersToArray = (data) => {
            const result = [];

            // 1. 收集所有存在的索引（如1,3,5...）
            const indexes = new Set();
            for (const key in data) {
                if (key.startsWith('ownerName')) {
                    const index = key.replace('ownerName', '');
                    indexes.add(parseInt(index));
                } else if (key.startsWith('ownerRatio')) {
                    const indexRatio = key.replace('ownerRatio', '');
                    indexes.add(parseInt(indexRatio));
                }
            }

            // 2. 对每个存在的索引提取数据
            indexes.forEach(index => {
                const ownerName = data[`ownerName${index}`];
                const ownerCode = data[`ownerCode${index}`];
                const ownerRatio = data[`ownerRatio${index}`];
                // 确保至少有一个字段存在（避免无效索引）
                if (ownerName || ownerCode || ownerRatio) {
                    result.push({
                        ownerName: ownerName, // 不存在则填充null
                        ownerCode: ownerCode,
                        ownerRatio: ownerRatio
                    });
                }
            });
            return result;
        };
        const delAction = (row) => {
            MessageBox.confirm(`确认要删除当前行数据 ? `, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                delDetailList({
                    flowCode: detailDataLocal.value.flowCode,
                    idList: [row.id]
                }).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('删除成功');
                    }
                }).finally(() => {
                    detailList.getList();
                });
            });
        };
        const subLoading = ref(false);
        const handleSubmit = async () => {
            subLoading.value = true;
            const params = {
                flowCode: detailDataLocal.value.flowCode
            };
            sharingRulesSubmit(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('提交成功');
                    detailDataLocal.value = { ...detailDataLocal.value, ...res.data };
                    refleshPage();
                }
            }).finally(() => {
                subLoading.value = false;
            });
        };
        const getiflowInfo = async (customerChange = ctx.$route.query.customerChange) => {
            const iflowRes = await contractWorkflowList({ contractCode: customerChange });
            if (+iflowRes.code === 0 && iflowRes.data && iflowRes.data.list && iflowRes.data.list.length) {
                const { mipId, mipStatus } = iflowRes.data.list[0];
                detailDataLocal.value.mipId = mipId;
                detailDataLocal.value.mipStatus = mipStatus;
            }
        };
        const handleChangeRow = _.debounce(({ prop, val, type, row, index }) => {
            if (prop === 'respOwnerName') {
                if (val?.respOwnerId) {
                    const params = {
                        ...detailDataLocal.value,
                        saveType: 'update',
                        list: rowsFormatFn([row]),
                        applicant: userCode,
                        respOwnerId: val?.respOwnerId || undefined
                    };
                    seveDetails(params);
                } else {
                    Message.warning('修改后责任人不能为空');
                    detailList.getList();
                }
            }
        }, MAGIC_NUMBER.FIVE_HUNDRED);
        const searchDataFormat = (condition = {}, params = {}, name) => {
            const { flowCode } = ctx.$route.query || detailDataLocal.value.flowCode;
            if (condition.failTime && condition.failTime.length) {
                condition.startTime = utils.formatDateTime(condition.failTime[0]);
                condition.endTime = utils.formatDateTime(condition.failTime[1]);
                Reflect.deleteProperty(condition, 'failTime');
            }
            if (condition.effectTime && condition.effectTime.length) {
                condition.effectStartTime = utils.formatDateTime(condition.effectTime[0]);
                condition.effectEndTime = utils.formatDateTime(condition.effectTime[1]);
                Reflect.deleteProperty(condition, 'effectTime');
            }
            const { customerCodes: customerCodeList, companyCodes: companyCodeList, businessCenterCodes: businessCenterCodeList,
                ownerCodes: ownerCodeList, ...rest } = condition;
            const newCondition = { customerCodeList, companyCodeList, businessCenterCodeList, ownerCodeList, ...rest };
            const keys = ['customerCodeList', 'companyCodeList', 'businessCenterCodeList',
                'ownerCodeList'];
            keys.forEach(key => {
                if (newCondition[key]) {
                    newCondition[key] = newCondition[key].split(',');
                }
            });
            Reflect.deleteProperty(newCondition, 'businessCenterNames');
            Reflect.deleteProperty(newCondition, 'companyNames');
            Reflect.deleteProperty(newCondition, 'customerNames');
            Reflect.deleteProperty(newCondition, 'ownerNames');
            newCondition.flowCode = flowCode;
            newCondition.applicant = userCode;
            Object.keys(newCondition).forEach(v => {
                !newCondition[v] && newCondition[v] !== 0 && (newCondition[v] = undefined);
            });

            return { ...newCondition, ...params };
        };
        const selectedRows = ref([]);

        // 编辑表格保存数据格式化
        const rowsFormatFn = (list = []) => {
            return list.map(item => {
                return _.omit(item, ['backup', 'edit', 'allowEdit', 'serialNum']);
            });
        };
        // 变更明细表保存
        const seveDetails = async (params) => {
            await getiflowInfo();
            if (!readonly.value) {
                const newParams = _.omit(params, ['applicantCode', 'applicantName', 'mipStatus', 'departName']);
                const res = await neoRespChangeSave(newParams);
                if (res && +res.code === 0) {
                    Message.success('保存成功');
                    refleshPage();
                }
            } else {
                return Message.warning('页面状态与实际流程状态不符，请刷新页面再操作');
            }
        };

        const updateData = ref({});
        const showDownload = ref(true);
        const upLoadData = (data) => {
            fileUrlList.value = {};
            showDownload.value = false;
            filesForm.value.accessoryName = '';
            addDialog.value = true;
        };
        const handleDeleteFile = (row) => {
            sharingFileDel({ id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    Message.success('删除成功');
                    refleshPage();
                }
            });
        };
        const currentUseRole = ref(false);
        const getRole = () => {
            return getCurrentUserRole().then(res => {
                if (res && +res.code === 0) {
                    currentUseRole.value = res.data;
                }
            }).catch(() => {
                btnloading.value = false;
            });
        };
        // iflow相关：
        const newMip = ref(false);
        const mipUrl = ref('');
        const handleCreate = () => {
            // eslint-disable-next-line max-len
            mipUrl.value = `${configurl.iflowUrl}?fdId=${detailDataLocal.value.mipId}&fdTemplateKey=CRM_income_sharing_rules&userCode=${userCode}&userName=${userName}&timestamp=${new Date().getTime()}`;
            // createMetaNode();
            window.addEventListener('message', messageFunc, false);
            const elementRules = document.querySelector('.sharing-rules');
            elementRules && elementRules.scrollTo({
                top: scrollHeight.value,
                left: 0,
                behavior: 'smooth' // 可选值：'auto'（默认）或'smooth'（平滑滚动）
            });

            if (newMip.value) { // 新产生的审批流，自动滚动到审批位置
                const timer = setTimeout(() => {
                    const element = document.getElementsByClassName('mip-iframe')[0];
                    element && element.scrollTo(0, MAGIC_NUMBER.ONE_THOUSAND); // 页面滚动到MIP审批位置
                    newMip.value = false;
                    clearTimeout(timer);
                }, MAGIC_NUMBER.FOUR_HUNDRED);
            }
        };
        // const createMetaNode = () => {
        //     const mipmeta = document.getElementById('mipmeta');
        //     if (mipmeta) {
        //         return false;
        //     }
        //     const meta = document.createElement('meta');
        //     meta.httpEquiv = 'Content-Security-Policy';
        //     meta.content = 'upgrade-insecure-requests';
        //     meta.id = 'mipmeta';
        //     document.getElementsByTagName('head')[0].appendChild(meta);
        // };
        const scrollHeight = ref(0);
        // eslint-disable-next-line complexity
        const messageFunc = (event) => {
            if (currentTime.value !== store.getters.iflowPage.pageTime) return;
            if (event.data && event.data.data && event.data.success) {
                const { flowCode, flowTitle } = detailDataLocal.value;
                const { origin, pathname } = window.location;
                const params = event.data.data || {};
                const { tenantCode } = store.getters.currentTenant;
                params.tenantCode = tenantCode;
                // params.currentApplicationCode = this.applicationCode;
                params.currentApplicationCode = 'APP201904230047';
                if (params.formParam) {
                    params.formParam.formInstanceId = flowCode;
                    const { processParam } = params;
                    let isToOtherPersons = '';
                    if (processParam.operationType === 'circulate' && processParam.toOtherPersons) {
                        isToOtherPersons = processParam.toOtherPersons; // 被传阅的人
                    }
                    // eslint-disable-next-line max-len
                    params.formParam.fdUrl = `${origin}${pathname}#/incomeSharingRules?flowCode=${flowCode}${isToOtherPersons ? `&isToOtherPersons=${isToOtherPersons}` : ''}`; // mip代办跳转URL
                    params.formParam.subject = flowTitle;
                    const { subjectForMultiLanguages } = params.formParam;
                    subjectForMultiLanguages?.length && subjectForMultiLanguages.forEach(item => {
                        item.subject = flowTitle;
                    });
                }
                btnloading.value = true;
                approveProcess(params).then(res => {
                    if (res && +res.code === 0) {
                        Message.success('提交成功');
                        const timer = setTimeout(() => {
                            refleshPage();
                            btnloading.value = false;
                            clearTimeout(timer);
                        }, MAGIC_NUMBER.THREE_THOUSAND);
                    } else {
                        Message.error(res.msg);
                    }
                }).catch(() => {
                    btnloading.value = false;
                }).finally(() => {
                    const finallyTimer = setTimeout(() => {
                        btnloading.value = false;
                        clearTimeout(finallyTimer);
                    }, MAGIC_NUMBER.THREE_THOUSAND);
                });
            }
        };
        // 提交审批校验- 校验变更明细存在责任人
        const checkSubmit = async () => {
            submitLoading.value = true;
            const params = {
                flowCode: detailDataLocal.value.flowCode
            };
            return sharingRulesCheck(params).catch(() => {
                submitLoading.value = false;
            });
        };
        const currentTime = ref('');
        // eslint-disable-next-line complexity
        const submitMip = async () => {
            // eslint-disable-next-line complexity
            const { flowCode, mipId } = detailDataLocal.value;
            // 审批流状态为 1: 草稿, 5: 驳回, 6: 撤回
            if ([1, 5, 6].includes(+detailDataLocal.value.mipStatus)) {
                const resCheck = await checkSubmit();
                if (+resCheck.code !== 0) {
                    submitLoading.value = false;
                    return false;
                }
            }
            const element = document.querySelector('.sharing-rules');
            const scrollTop = element.scrollTop; // 当前滚动位置
            scrollHeight.value = scrollTop;
            submitLoading.value = true;
            // mip提交前校验页面流程信息与流程实际信息是否符合
            const iflowRes = await contractWorkflowList({ contractCode: flowCode });
            submitLoading.value = false;
            if (iflowRes?.code === '0') {
                if (iflowRes.data?.list?.length && iflowRes.data.list[0].mipId === mipId) {
                    const content = window;
                    content.frames && content.frames.length && content.frames[0]
                        && content.frames[0].postMessage('mbpm_getApprovalData', mipUrl.value);
                    content.frames && content.frames.length && content.frames[1]
                        && content.frames[1].postMessage('mbpm_getApprovalData', mipUrl.value); // 解决接入了智能客服后，content.frames[0]被占用了的问题
                    currentTime.value = new Date().getTime();
                    store.commit('updateIflowPage', { pageTime: currentTime.value });
                } else {
                    Message.warning('页面审批流程信息已过期，请刷新页面再试');
                    return false;
                }
            } else {
                return false;
            }
        };
        const handlePreview = (row) => {
            filePreview({
                fileUrl: row.internalSealFileUrl,
                fileName: row.accessoryName
            });
        };
        const deleteAllLoading = ref(false);
        // eslint-disable-next-line max-lines-per-function
        const handleDelete = () => {
            //       detailList.getList();
            if (!detailList.selectedRows.value.length) {
                Message.warning('请勾选要删除的数据');
                return false;
            } else {
                MessageBox.confirm('是否确认要删除?', '提示', {
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    const ids = detailList.selectedRows.value.filter(item => !!item.id).map(sub => sub.id);
                    delDetailList({
                        flowCode: detailDataLocal.value.flowCode,
                        idList: ids
                    }).then(res => {
                        if (res && +res.code === 0) {
                            Message.success('删除成功');
                        }
                    }).finally(() => {
                        detailList.getList();
                    });
                });
            }
        };
        const roleAuth = ref(false);
        const getRoleAuth = () => {
            return getCurrentPrivilegeRole({}).then(res => {
                if (res && +res.code === 0) {
                    roleAuth.value = res.data; // true 显示2个选项, false显示一个
                }
            });
        };
        const isPrivilege = ref(false);
        const getPrivilege = () => {
            return getCurrentPrivilege().then(res => {
                if (res && +res.code === 0) {
                    isPrivilege.value = res.data; // true 显示2个选项, false显示一个
                }
            });
        };
        const changeEffecttimeHandle = (data) => {
            if (!data) return;
            if (!detailList.totalData.value.length) {
                return Message.warning('请添加变更提成分配规则后再操作');
            }
            const params = {
                flowCode: detailDataLocal.value.flowCode,
                idList: detailList.totalData.value.map(it => it.id),
                effectStartTime: data
            };
            updateEffectDate(params).then(res => {
                if (res && +res.code === 0) {
                    Message.success('批量更新生效日期成功');
                }
            }).finally(() => {
                changeEffectTime.value = '';
                detailList.getList();
            });
        };
        onActivated(() => {
            // eslint-disable-next-line no-unused-expressions
            setupContext.refs.editTableBox?.$refs.moduleTable.doLayout(); // 解决表格错位
            const { flowCode } = ctx.$route.query;
            if (!flowCode) {
                detailDataLocal.value = {};
                detailList.totalData.value = [];
                detailList.pageTotal.value = 0;
                detailList.pageNo.value = 0;
                detailList.pageSize.value = 10;
            }
        });
        // const isPrivilege = computed(() => {
        //     const data = dictDatas.value.LCRM_PRIVILEGED_ROLE_LIST;
        //     return data?.CUSTOMER_MANAGER_DIVIDE?.split(',').includes(userCode);
        // });
        const dictDatas = ref({});
        const initShowLoading = ref(false);
        onMounted(async() => {
            initShowLoading.value = true;
            const res = await getDictDataApi({
                dictCodes: 'NEOCRM_CUSTOMER_LEVEL,SYS_CUST_RELATION_TYPE,LCRM_IMPORT_MAX_SIZE'
            });
            dictDatas.value = res.data;
            await getRole();
            await getRoleAuth();
            await getPrivilege();
            await refleshPage();
            await getIflowhandlers(detailDataLocal.value?.contractWorkflowInfo?.mipId);
            initShowLoading.value = false;
        });
        return {
            config,
            newConfig,
            btnloading,
            readonly,
            detailDataLocal,
            rules,
            detailLoading,
            refleshPage,
            isFull,
            detailList,
            handleChangeRow,
            upLoadData,
            handleDeleteFile,
            selectedRows,
            mipUrl,
            handleCreate,
            submitMip,
            selectKey,
            deleteAllLoading,
            submitLoading,
            downLoad,
            fileList,
            filesForm,
            addDialog,
            openImport,
            downloadLoading,
            closeLog,
            handleError,
            onChange,
            importLoading,
            handleImport,
            handleExport,
            changeData,
            detailExportLoading,
            contractSaveSure,
            handleSave,
            saveLoading,
            actionClick,
            sharingRulesShow,
            updateData,
            handleSubmit,
            subLoading,
            beforeUploadPick,
            getUploadFilePick,
            incrementImport,
            showDownload,
            beforeUploadUrl,
            upLoadFileUrl,
            fileUrlList,
            hasAuthorized,
            initShowLoading,
            handlePreview,
            isShowBtnFlow,
            handleDelete,
            changeEffectTime,
            changeEffecttimeHandle,
            isPrivilege
        };
    }
};
</script>
<style lang="less" scope>
.sharing-rules {
    overflow: scroll;
    width: 100%;
    height: 100%;
        .header-box {
            width: 100%;
            h4 {
                text-align: center;
                font-size: 20px;
                margin: 0;
                color: #606266;
                // border-bottom: 1px solid #dde0e6;
                margin-bottom: 10px;
                padding-bottom: 5px;
            }
        }
        .header-part {
            height: 32px;
            .apply-info {
                float: right;
                font-size: 14px;
                width: 230px;
                line-height: 20px;
                color: #606266;
            }
        }
        .el-menu.el-menu--horizontal {
            width: 150px;
            .el-menu-item {
                height: 35px;
                line-height: 35px;
                font-weight: 600;
                font-size: 16px;
                &.is-active {
                    color: #4285F5
                }
            }
        }
    .table-box,
    .edit-table-box {
        margin-bottom: 5px;
        .edit-filter-box {
            display: inline-block;
            width: 60px;
            .el-input__inner {
                padding-right: 24px;
            }
        }
    }
    .el-pagination {
        float: right;
    }
    .list-box {
        padding-right: 10px;
        &.second-box {
            &.margin-box {
                margin-top: 25px;
            }
        }
        &.third-box {
            margin-top: 45px;
            border-bottom: 1px solid #ebeef5;
        }
        .model-table-search {
            margin-top: 10px;
        }

    }
       .file-infos {
            width: 100%;
            padding: 0 10px 0 0;
           .file-list {
                width: 100%;
                padding: 2px 0 2px 4px;
                display: flex;
                // align-items: center;
                // justify-content: space-between;
                .file-name {
                    // flex: 1;
                    &.upload {
                        width: 500px;
                    }
                    padding-right: 5px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: inline-block;
                    // margin-right: 30px;
                }
                .view-btn, .delete-btn {
                    width: 200px;
                    display: flex;
                    a {
                        text-decoration: none;
                        color: #4285F5;
                    }
                    .el-button {
                        margin-left: 10px;
                    }
                    .el-button:focus,.el-button:hover, .el-button:active,.el-button.is-disabled{
                        outline: none !important;
                        border-color: transparent !important; /* 可选：如果要去除激活时的边框颜色变化 */
                    }
                }
            }
        }
    .iflow-box {
        .header-operation {
            margin-top: 10px;
        }
        iframe {
            width: 100%;
            height: 100vh;
            border: none;
        }
    }
}
.sharing-rules {
        .upload-btn {
        display: flex;
        // padding: 0px 0px 15px 80px;
        margin: 0 0 0 8px;
        .upload-demo {
            margin-left: 10px;
        }
    }
    .income-date-change{
        display: inline-block;
        .el-date-editor.el-input, .el-date-editor.el-input__inner{
            width: 20px;
        }
        input {
            opacity: 0;
        }
        .el-input__prefix{
            cursor: pointer;
        }
        .el-input__suffix .el-input__icon{
           display: none;
        }
    }
}
.upload-box{
    display: flex;
    align-items: center;
    margin: 16px 0;
    .upload-sharing-btn{
        margin-left: 28px;
    }
    .upload-label{
        line-height: 28px;
        font-size: 14px;
        color: #606266;
    }
}
.no-auth-reg {
    font-size: 16px;
    padding: 20px;
    background: #fff;
    width: 100%;
}
.income-sharing{
    // opacity: 0;
    // transition: opacity 1s;
    transition: opacity 1s ease, visibility 1s ease;
}

</style>
